var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27177",
    "data-name": "Group 27177",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8399",
    "data-name": "Rectangle 8399",
    width: 26,
    height: 26,
    transform: "translate(2)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bxs-discount",
    d: "M31.5,7.5H4.5A1.5,1.5,0,0,0,3,9v6H4.34a3.113,3.113,0,0,1,3.12,2.5A3,3,0,0,1,4.5,21H3v6a1.5,1.5,0,0,0,1.5,1.5h27A1.5,1.5,0,0,0,33,27V21H31.5a3,3,0,0,1-2.96-3.5A3.113,3.113,0,0,1,31.66,15H33V9A1.5,1.5,0,0,0,31.5,7.5Zm-18,6A1.5,1.5,0,1,1,12,15,1.5,1.5,0,0,1,13.5,13.5Zm-1.2,9.6,9-12,2.4,1.8-9,12-2.4-1.8Zm10.2-.6A1.5,1.5,0,1,1,24,21,1.5,1.5,0,0,1,22.5,22.5Z",
    transform: "translate(-3 -4.925)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountRequest);
export default __webpack_public_path__ + "static/media/discountRequest.7758caec.svg";
export { ForwardRef as ReactComponent };